export interface ComicChapter {
  id: string;
  title: string;
  index: number;
  updateDate: string;
}

export interface ComicArticle {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  chapters: ComicChapter[];
  updateDate: string;
  rating: number;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  isCompleted: boolean;
  content: string[];
}

export const comics: ComicArticle[] = [
  {
    id: "1",
    title: "霸道总裁的契约新娘",
    author: "金秀贤",
    category: "恋爱",
    categorySlug: "lianai",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20style%20illustration%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20clean%20composition%2C%20delicate%20line%20art%2C%20romantic%20atmosphere%2C%20webtoon%20cover%20design%2C%20simple%20background%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "被家族逼迫联姻的她，意外嫁给了全城最危险的男人。原以为是一场无爱的交易婚姻，却发现这个冷漠的总裁，竟然默默守护了她十年...一段契约婚姻，两颗真心相付。",
    chapters: [
      { id: "ch1-1", title: "第1话 意外的婚约", index: 1, updateDate: "2026-08-04" },
      { id: "ch1-2", title: "第2话 冷面总裁", index: 2, updateDate: "2026-08-03" },
      { id: "ch1-3", title: "第3话 同居生活", index: 3, updateDate: "2026-08-02" },
      { id: "ch1-4", title: "第4话 深夜的温柔", index: 4, updateDate: "2026-08-01" },
      { id: "ch1-5", title: "第5话 前任归来", index: 5, updateDate: "2026-07-31" },
      { id: "ch1-6", title: "第6话 信任危机", index: 6, updateDate: "2026-07-30" },
      { id: "ch1-7", title: "第7话 真相大白", index: 7, updateDate: "2026-07-29" },
      { id: "ch1-8", title: "第8话 甜寵告白", index: 8, updateDate: "2026-07-28" },
    ],
    updateDate: "2026-08-04",
    rating: 9.6,
    views: 1285000,
    tags: ["甜宠", "契约婚姻", "霸总", "先婚后爱"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "2",
    title: "重生之豪门千金复仇记",
    author: "李恩智",
    category: "恋爱",
    categorySlug: "lianai",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20cover%2C%20elegant%20woman%20in%20luxurious%20dress%2C%20revenge%20theme%2C%20sophisticated%20illustration%2C%20warm%20golden%20tones%2C%20clean%20minimal%20background%2C%20manhwa%20art%20style%2C%20delicate%20details&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "前世被最亲近的人背叛致死，一睁眼竟回到了十年前！这一世，她要让所有伤害过她的人付出代价。但那个一直陪在身边的他，似乎和前世完全不同...",
    chapters: [
      { id: "ch2-1", title: "第1话 浴火重生", index: 1, updateDate: "2026-08-04" },
      { id: "ch2-2", title: "第2话 再见故人", index: 2, updateDate: "2026-08-03" },
      { id: "ch2-3", title: "第3话 第一步棋", index: 3, updateDate: "2026-08-02" },
      { id: "ch2-4", title: "第4话 暗流涌动", index: 4, updateDate: "2026-08-01" },
      { id: "ch2-5", title: "第5话 棋逢对手", index: 5, updateDate: "2026-07-31" },
      { id: "ch2-6", title: "第6话 意外盟友", index: 6, updateDate: "2026-07-30" },
    ],
    updateDate: "2026-08-04",
    rating: 9.8,
    views: 2150000,
    tags: ["重生", "复仇", "豪门", "逆袭"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "3",
    title: "剑与魔法之龙骑士传说",
    author: "朴志勋",
    category: "奇幻",
    categorySlug: "qihuan",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20dragon%20knight%20with%20sword%20and%20magic%2C%20epic%20illustration%2C%20dramatic%20lighting%2C%20clean%20background%2C%20webtoon%20style%2C%20character%20centered%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "在一个被龙族统治的世界，少年艾德偶然觉醒了失落的龙骑士之力。从此踏上寻找传说中七颗龙晶的冒险之旅，却不料牵出了一个足以颠覆整个世界的惊天阴谋...",
    chapters: [
      { id: "ch3-1", title: "第1话 觉醒之日", index: 1, updateDate: "2026-08-04" },
      { id: "ch3-2", title: "第2话 初遇龙族", index: 2, updateDate: "2026-08-03" },
      { id: "ch3-3", title: "第3话 骑士试炼", index: 3, updateDate: "2026-08-02" },
      { id: "ch3-4", title: "第4话 第一颗龙晶", index: 4, updateDate: "2026-08-01" },
      { id: "ch3-5", title: "第5话 暗影来袭", index: 5, updateDate: "2026-07-31" },
    ],
    updateDate: "2026-08-04",
    rating: 9.5,
    views: 980000,
    tags: ["奇幻", "冒险", "龙", "魔法"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "4",
    title: "暗夜猎手：吸血鬼日记",
    author: "崔俊昊",
    category: "动作",
    categorySlug: "dongzuo",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20vampire%20hunter%20in%20dark%20city%2C%20noir%20atmosphere%2C%20dramatic%20illustration%2C%20red%20and%20black%20tones%2C%20webtoon%20style%2C%20clean%20composition%2C%20professional%20art&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "在首尔繁华的夜色之下，隐藏着一个不为人知的吸血鬼世界。半人半吸血鬼的猎手金泰亨，背负着父母被杀的仇恨，誓要将所有嗜血怪物斩尽杀绝。",
    chapters: [
      { id: "ch4-1", title: "第1话 夜行之人", index: 1, updateDate: "2026-08-03" },
      { id: "ch4-2", title: "第2话 血之契约", index: 2, updateDate: "2026-08-02" },
      { id: "ch4-3", title: "第3话 猎杀时刻", index: 3, updateDate: "2026-08-01" },
      { id: "ch4-4", title: "第4话 宿敌现身", index: 4, updateDate: "2026-07-31" },
      { id: "ch4-5", title: "第5话 夜幕降临", index: 5, updateDate: "2026-07-30" },
    ],
    updateDate: "2026-08-03",
    rating: 9.3,
    views: 756000,
    tags: ["动作", "吸血鬼", "都市", "暗黑"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "5",
    title: "时光倒流的那个夏天",
    author: "郑多彬",
    category: "剧情",
    categorySlug: "juqing",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20youth%20summer%20nostalgia%2C%20warm%20sunset%20colors%2C%20emotional%20illustration%2C%20clean%20minimal%20background%2C%20webtoon%20style%2C%20delicate%20art%2C%20reflective%20mood&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "一场意外让27岁的她回到17岁的夏天。那个曾经错过的少年，那段未说完的话，这次她能否改变命运的安排？一部关于青春、遗憾与重来的暖心故事。",
    chapters: [
      { id: "ch5-1", title: "第1话 那个夏天", index: 1, updateDate: "2026-08-02" },
      { id: "ch5-2", title: "第2话 初见", index: 2, updateDate: "2026-08-01" },
      { id: "ch5-3", title: "第3话 未寄出的信", index: 3, updateDate: "2026-07-31" },
      { id: "ch5-4", title: "第4话 错过的约定", index: 4, updateDate: "2026-07-30" },
      { id: "ch5-5", title: "第5话 再次相遇", index: 5, updateDate: "2026-07-29" },
    ],
    updateDate: "2026-08-02",
    rating: 9.7,
    views: 620000,
    tags: ["剧情", "穿越", "青春", "治愈"],
    isHot: false,
    isNew: false,
    isCompleted: true,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "6",
    title: "废柴逆袭：从零开始的异世界",
    author: "尹世勋",
    category: "搞笑",
    categorySlug: "gaoxiao",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20character%20in%20fantasy%20world%2C%20colorful%20illustration%2C%20humorous%20expression%2C%20webtoon%20style%2C%20bright%20and%20lively%20composition%2C%20clean%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "游戏宅男李浩宇意外穿越到了自己玩的游戏世界，却成了一个最废柴的NPC！没有战斗力、没有魔法天赋，他唯一的优势是——知道所有剧情走向。看废柴如何利用游戏知识逆天改命！",
    chapters: [
      { id: "ch6-1", title: "第1话 社畜的日常", index: 1, updateDate: "2026-08-03" },
      { id: "ch6-2", title: "第2话 异世界降临", index: 2, updateDate: "2026-08-02" },
      { id: "ch6-3", title: "第3话 废柴人生", index: 3, updateDate: "2026-08-01" },
      { id: "ch6-4", title: "第4话 第一个金手指", index: 4, updateDate: "2026-07-31" },
      { id: "ch6-5", title: "第5话 菜鸟变大佬", index: 5, updateDate: "2026-07-30" },
    ],
    updateDate: "2026-08-03",
    rating: 9.1,
    views: 1340000,
    tags: ["搞笑", "异世界", "游戏", "逆袭"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "7",
    title: "迷雾之城：第7号案件",
    author: "韩瑞俊",
    category: "悬疑",
    categorySlug: "xuanyi",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20foggy%20city%20noir%20atmosphere%2C%20detective%20theme%2C%20dark%20moody%20illustration%2C%20clean%20composition%2C%20webtoon%20style%2C%20suspenseful%20design&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "首尔连续发生离奇失踪案件，所有的线索都指向一个早已废弃的地铁站。刑警朴成浩深入调查，却发现每个失踪者之间都有一个惊人的共同点——他们都在同一时间下载过一个神秘的APP...",
    chapters: [
      { id: "ch7-1", title: "第1话 失踪者", index: 1, updateDate: "2026-08-01" },
      { id: "ch7-2", title: "第2话 废弃站台", index: 2, updateDate: "2026-07-31" },
      { id: "ch7-3", title: "第3话 神秘APP", index: 3, updateDate: "2026-07-30" },
      { id: "ch7-4", title: "第4话 共同点", index: 4, updateDate: "2026-07-29" },
      { id: "ch7-5", title: "第5话 十三年前的秘密", index: 5, updateDate: "2026-07-28" },
    ],
    updateDate: "2026-08-01",
    rating: 9.4,
    views: 890000,
    tags: ["悬疑", "推理", "都市", "犯罪"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "8",
    title: "校草大人请自重",
    author: "林秀晶",
    category: "校园",
    categorySlug: "xiaoyuan",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20campus%20youth%20theme%2C%20bright%20cheerful%20illustration%2C%20cherry%20blossoms%2C%20webtoon%20style%2C%20clean%20background%2C%20fresh%20and%20sweet%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "全校女生心中的白马王子，却偏偏对平凡的她死缠烂打？当校草在全校面前宣布「她是我的女朋友」，苏小冉的校园生活彻底失控了...",
    chapters: [
      { id: "ch8-1", title: "第1话 转学生", index: 1, updateDate: "2026-08-04" },
      { id: "ch8-2", title: "第2话 校草的关注", index: 2, updateDate: "2026-08-03" },
      { id: "ch8-3", title: "第3话 图书馆偶遇", index: 3, updateDate: "2026-08-02" },
      { id: "ch8-4", title: "第4话 晴天霹雳", index: 4, updateDate: "2026-08-01" },
      { id: "ch8-5", title: "第5话 轰动全校", index: 5, updateDate: "2026-07-31" },
    ],
    updateDate: "2026-08-04",
    rating: 9.2,
    views: 1650000,
    tags: ["校园", "甜宠", "双向暗恋", "青春"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "9",
    title: "凤求凰：宫女升职记",
    author: "南宫羽",
    category: "古风",
    categorySlug: "gufeng",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%2C%20ancient%20Chinese%20style%20palace%2C%20elegant%20woman%20in%20traditional%20hanbok%2C%20watercolor%20illustration%2C%20delicate%20art%2C%20clean%20background%2C%20poetic%20atmosphere%2C%20refined%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "一介小小宫女，凭借过人的智慧和胆识，在后宫步步为营。从洗衣房的卑贱宫女到权倾后宫的令妃，她用十年时间书写了属于自己的传奇。但权力的游戏里，真的有赢家吗？",
    chapters: [
      { id: "ch9-1", title: "第1话 入宫", index: 1, updateDate: "2026-08-03" },
      { id: "ch9-2", title: "第2话 第一次侍寝", index: 2, updateDate: "2026-08-02" },
      { id: "ch9-3", title: "第3话 后宫风云", index: 3, updateDate: "2026-08-01" },
      { id: "ch9-4", title: "第4话 步步惊心", index: 4, updateDate: "2026-07-31" },
      { id: "ch9-5", title: "第5话 册封大典", index: 5, updateDate: "2026-07-30" },
    ],
    updateDate: "2026-08-03",
    rating: 9.5,
    views: 720000,
    tags: ["古风", "宫廷", "权谋", "大女主"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "10",
    title: "魔王的秘密花园",
    author: "金泰妍",
    category: "奇幻",
    categorySlug: "qihuan",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20dark%20castle%20with%20magical%20garden%2C%20mysterious%20atmosphere%2C%20elegant%20illustration%2C%20dramatic%20lighting%2C%20webtoon%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "魔王大人战无不胜，却被一个人类女孩偷走了心。传说中嗜血冷酷的魔王，其实最喜欢在秘密花园里种花养草。当战争结束，他只想和心爱的她，在自己的秘密花园里安静度过余生。",
    chapters: [
      { id: "ch10-1", title: "第1话 战场上的邂逅", index: 1, updateDate: "2026-08-04" },
      { id: "ch10-2", title: "第2话 俘虏", index: 2, updateDate: "2026-08-03" },
      { id: "ch10-3", title: "第3话 花园的秘密", index: 3, updateDate: "2026-08-02" },
      { id: "ch10-4", title: "第4话 心动的瞬间", index: 4, updateDate: "2026-08-01" },
      { id: "ch10-5", title: "第5话 告白", index: 5, updateDate: "2026-07-31" },
    ],
    updateDate: "2026-08-04",
    rating: 9.6,
    views: 1850000,
    tags: ["奇幻", "魔王", "甜宠", "反差萌"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "11",
    title: "武道宗师之巅峰对决",
    author: "姜虎东",
    category: "动作",
    categorySlug: "dongzuo",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20fighter%20in%20dynamic%20pose%2C%20action%20illustration%2C%20dramatic%20energy%20effects%2C%20webtoon%20style%2C%20clean%20background%2C%20powerful%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "废柴高中生崔元昊，在被全校霸凌后意外获得上古武道传承。三年后，他重回校园，那些曾经欺负过他的人，将亲身感受什么叫真正的绝望...",
    chapters: [
      { id: "ch11-1", title: "第1话 废柴人生", index: 1, updateDate: "2026-08-02" },
      { id: "ch11-2", title: "第2话 传承", index: 2, updateDate: "2026-08-01" },
      { id: "ch11-3", title: "第3话 三年之约", index: 3, updateDate: "2026-07-31" },
      { id: "ch11-4", title: "第4话 王者归来", index: 4, updateDate: "2026-07-30" },
      { id: "ch11-5", title: "第5话 一拳之威", index: 5, updateDate: "2026-07-29" },
    ],
    updateDate: "2026-08-02",
    rating: 9.3,
    views: 1120000,
    tags: ["动作", "武道", "校园", "热血"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "12",
    title: "搞笑一家人之穿越异界",
    author: "朴明秀",
    category: "搞笑",
    categorySlug: "gaoxiao",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20family%20comedy%20manhwa%20cover%2C%20funny%20family%20in%20fantasy%20world%2C%20colorful%20humorous%20illustration%2C%20bright%20and%20lively%2C%20webtoon%20style%2C%20clean%20background%2C%20playful%20design&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "一家五口人在搬家途中意外穿越到了剑与魔法的世界！爸爸成了最强剑士，妈妈成了大魔导师，三个熊孩子则成了比魔王还恐怖的存在...史上最爆笑的异世界冒险开始了！",
    chapters: [
      { id: "ch12-1", title: "第1话 搬家日", index: 1, updateDate: "2026-08-03" },
      { id: "ch12-2", title: "第2话 穿越", index: 2, updateDate: "2026-08-02" },
      { id: "ch12-3", title: "第3话 勇者一家", index: 3, updateDate: "2026-08-01" },
      { id: "ch12-4", title: "第4话 魔王哭了", index: 4, updateDate: "2026-07-31" },
      { id: "ch12-5", title: "第5话 爸爸的必杀技", index: 5, updateDate: "2026-07-30" },
    ],
    updateDate: "2026-08-03",
    rating: 9.4,
    views: 1450000,
    tags: ["搞笑", "穿越", "家庭", "异世界"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "13",
    title: "禁忌之恋：人鱼传说",
    author: "吴恩英",
    category: "恋爱",
    categorySlug: "lianai",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20mermaid%20and%20human%20love%20story%2C%20ocean%20theme%2C%20ethereal%20illustration%2C%20soft%20blue%20and%20white%20tones%2C%20webtoon%20style%2C%20clean%20composition%2C%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    description: "海洋生物学研究生在海边救下了一个神秘女子，她不会说话，却有着惊为天人的美貌。当他发现她双腿沾水就会变成鱼尾时，一段跨越物种的禁忌之恋悄然展开...",
    chapters: [
      { id: "ch13-1", title: "第1话 海边的她", index: 1, updateDate: "2026-08-01" },
      { id: "ch13-2", title: "第2话 秘密", index: 2, updateDate: "2026-07-31" },
      { id: "ch13-3", title: "第3话 人鱼之泪", index: 3, updateDate: "2026-07-30" },
      { id: "ch13-4", title: "第4话 追兵", index: 4, updateDate: "2026-07-29" },
      { id: "ch13-5", title: "第5话 选择", index: 5, updateDate: "2026-07-28" },
    ],
    updateDate: "2026-08-01",
    rating: 9.5,
    views: 960000,
    tags: ["恋爱", "奇幻", "人鱼", "禁忌之恋"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "14",
    title: "长安幻夜之狐妖传",
    author: "苏子墨",
    category: "古风",
    categorySlug: "gufeng",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20fox%20spirit%20in%20ancient%20Chinese%20city%2C%20mystical%20atmosphere%2C%20beautiful%20illustration%2C%20traditional%20elements%2C%20webtoon%20style%2C%20clean%20background%2C%20elegant%20design&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    description: "长安城中怪事频发，传言有狐妖出没。少年道士沈清玄奉命调查，却发现这狐妖并非害人之物，而是在寻找三百年前救过她的人类转世。一段跨越三生三世的人妖之恋，在长安的夜色中徐徐展开。",
    chapters: [
      { id: "ch14-1", title: "第1话 狐影", index: 1, updateDate: "2026-07-31" },
      { id: "ch14-2", title: "第2话 道士下山", index: 2, updateDate: "2026-07-30" },
      { id: "ch14-3", title: "第3话 初见", index: 3, updateDate: "2026-07-29" },
      { id: "ch14-4", title: "第4话 前世记忆", index: 4, updateDate: "2026-07-28" },
      { id: "ch14-5", title: "第5话 长安之约", index: 5, updateDate: "2026-07-27" },
    ],
    updateDate: "2026-07-31",
    rating: 9.7,
    views: 830000,
    tags: ["古风", "玄幻", "人妖恋", "宿命"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "15",
    title: "学霸的温柔陷阱",
    author: "宋智恩",
    category: "校园",
    categorySlug: "xiaoyuan",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20school%20comedy%20romance%20manhwa%20cover%2C%20smart%20student%20couple%2C%20library%20setting%2C%20warm%20and%20bright%20illustration%2C%20webtoon%20style%2C%20clean%20background%2C%20fresh%20youth%20atmosphere&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    description: "全校第一名和倒数第一名的座位被换到了一起。学霸表面高冷，实则是只对学渣才会心跳加速的纯情少年。而他布下的「补习陷阱」，渐渐让学渣沦陷了...",
    chapters: [
      { id: "ch15-1", title: "第1话 座位大换血", index: 1, updateDate: "2026-08-04" },
      { id: "ch15-2", title: "第2话 补习计划", index: 2, updateDate: "2026-08-03" },
      { id: "ch15-3", title: "第3话 图书馆之夜", index: 3, updateDate: "2026-08-02" },
      { id: "ch15-4", title: "第4话 心跳补习", index: 4, updateDate: "2026-08-01" },
      { id: "ch15-5", title: "第5话 成绩单上的告白", index: 5, updateDate: "2026-07-31" },
    ],
    updateDate: "2026-08-04",
    rating: 9.3,
    views: 1380000,
    tags: ["校园", "甜宠", "学霸", "学渣"],
    isHot: true,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
  {
    id: "16",
    title: "深夜书店：第13层",
    author: "郑宇成",
    category: "悬疑",
    categorySlug: "xuanyi",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20horror%20mystery%20manhwa%20cover%2C%20dark%20bookstore%20at%20night%2C%20eerie%20atmosphere%2C%20suspenseful%20illustration%2C%20webtoon%20style%2C%20clean%20composition%2C%20mysterious%20design&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    description: "深夜里，一家只在午夜开门的神秘书店。每个走进去的人都能找到一本关于自己的书——写满了未来的命运。但当他们试图改变书中的结局时，现实却变得更加恐怖...",
    chapters: [
      { id: "ch16-1", title: "第1话 午夜书店", index: 1, updateDate: "2026-07-30" },
      { id: "ch16-2", title: "第2话 命运之书", index: 2, updateDate: "2026-07-29" },
      { id: "ch16-3", title: "第3话 第一个读者", index: 3, updateDate: "2026-07-28" },
      { id: "ch16-4", title: "第4话 被改写的未来", index: 4, updateDate: "2026-07-27" },
      { id: "ch16-5", title: "第5话 书店的主人", index: 5, updateDate: "2026-07-26" },
    ],
    updateDate: "2026-07-30",
    rating: 9.2,
    views: 670000,
    tags: ["悬疑", "恐怖", "命运", "都市传说"],
    isHot: false,
    isNew: false,
    isCompleted: false,
    content: ["page1", "page2", "page3", "page4", "page5"],
  },
];

export const bannerComics = comics.filter(c => c.isHot).slice(0, 5);

export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);

export const rankingComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

export const recommendedComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);

export function getComicById(id: string): ComicArticle | undefined {
  return comics.find(c => c.id === id);
}

export function getComicsByCategory(slug: string): ComicArticle[] {
  return comics.filter(c => c.categorySlug === slug);
}

export function getRelatedComics(comic: ComicArticle, count: number = 4): ComicArticle[] {
  return comics
    .filter(c => c.categorySlug === comic.categorySlug && c.id !== comic.id)
    .slice(0, count);
}